(function () {
  'use strict';

  // ─── Defensive: als body.ugc-v2-lock blijft hangen maar geen lightbox open is, unlock ───
  // Voorkomt dat de pagina "stuck" raakt op mobile na back-gesture of onbedoelde close
  function safetyUnlock() {
    if (!document.body.classList.contains('ugc-v2-lock')) return;
    var anyOpen = document.querySelector('[data-ugc-lb].is-open');
    if (!anyOpen) {
      document.body.classList.remove('ugc-v2-lock');
    }
  }

  // Run unlock-check bij page visibility changes (tab switch, back button, etc)
  document.addEventListener('visibilitychange', safetyUnlock);
  window.addEventListener('pageshow', safetyUnlock);
  window.addEventListener('popstate', safetyUnlock);

  // Periodieke safety check (1x per seconde) — alleen actief als body locked is
  setInterval(safetyUnlock, 1000);

  function waitForSwiper(cb, tries) {
    tries = tries || 0;
    if (typeof Swiper !== 'undefined') { cb(); return; }
    if (tries > 50) return;
    setTimeout(function () { waitForSwiper(cb, tries + 1); }, 100);
  }

  function init(section) {
    if (section.dataset.ugcInit === 'true') return;
    section.dataset.ugcInit = 'true';

    const gridSwiperEl = section.querySelector('[data-ugc-swiper]');
    const lbSwiperEl = section.querySelector('[data-ugc-lb-swiper]');
    const lightbox = section.querySelector('[data-ugc-lb]');
    const prevBtn = section.querySelector('[data-ugc-prev]');
    const nextBtn = section.querySelector('[data-ugc-next]');
    const lbPrev = section.querySelector('[data-ugc-lb-prev]');
    const lbNext = section.querySelector('[data-ugc-lb-next]');
    const backdrop = section.querySelector('.ugc-v2-lb__backdrop');
    const closeBtn = section.querySelector('.ugc-v2-lb__close');
    const openBtns = section.querySelectorAll('[data-ugc-open]');

    // ---- GRID SWIPER ----
    if (!gridSwiperEl) return;

    const gridSwiper = new Swiper(gridSwiperEl, {
      slidesPerView: 2.2,
      spaceBetween: 12,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      breakpoints: {
        750: { slidesPerView: 3, spaceBetween: 16 },
        990: { slidesPerView: 5, spaceBetween: 16 },
      },
    });

    // ---- LIGHTBOX SWIPER ----
    let lbSwiper = null;

    function initLbSwiper(startIdx) {
      const isDesktop = window.innerWidth >= 750;
      if (lbSwiper) {
        lbSwiper.slideTo(startIdx, 0);
        setTimeout(function () { lbSwiper.update(); }, 50);
        return lbSwiper;
      }
      lbSwiper = new Swiper(lbSwiperEl, {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 16,
        initialSlide: startIdx,
        watchSlidesProgress: true,
        navigation: {
          prevEl: lbPrev,
          nextEl: lbNext,
        },
        keyboard: { enabled: true },
        on: {
          init: function () {
            this.update();
          },
          slideChange: function () {
            pauseAllLbVideos();
            setTimeout(playActiveLbVideo, 150);
          },
        },
      });
      setTimeout(function () {
        if (lbSwiper) lbSwiper.update();
      }, 100);
      return lbSwiper;
    }

    function pauseAllLbVideos() {
      section.querySelectorAll('[data-ugc-lb-video]').forEach(function (v) {
        v.pause();
      });
    }

    function lazyLoadLbVideo(slide) {
      const v = slide.querySelector('[data-ugc-lb-video]');
      if (!v || v.dataset.ugcLoaded === 'true') return v;
      const srcs = v.querySelectorAll('source[data-lazy-src]');
      srcs.forEach(function (s) { s.src = s.dataset.lazySrc; });
      v.load();
      v.dataset.ugcLoaded = 'true';
      return v;
    }

   function playActiveLbVideo() {
      if (!lbSwiper) return;
      const activeSlide = lbSwiper.slides[lbSwiper.activeIndex];
      if (!activeSlide) return;
      lazyLoadLbVideo(activeSlide);
      if (lbSwiper.slides[lbSwiper.activeIndex - 1]) lazyLoadLbVideo(lbSwiper.slides[lbSwiper.activeIndex - 1]);
      if (lbSwiper.slides[lbSwiper.activeIndex + 1]) lazyLoadLbVideo(lbSwiper.slides[lbSwiper.activeIndex + 1]);

      const v = activeSlide.querySelector('[data-ugc-lb-video]');
      if (!v) return;
      // Respect section setting for initial muted state
      const startMuted = section.getAttribute('data-ugc-start-muted') !== 'false';
      v.muted = startMuted;
      v.play().catch(function(){
        // Autoplay with sound blocked by browser — fallback to muted
        if (!startMuted) {
          v.muted = true;
          v.play().catch(function(){});
          updateIcons(activeSlide);
        }
      });
      updateIcons(activeSlide);
    }

    function updateIcons(slide) {
      const v = slide.querySelector('[data-ugc-lb-video]');
      if (!v) return;
      const pi = slide.querySelector('.ugc-v2-pi');
      const pa = slide.querySelector('.ugc-v2-pa');
      const un = slide.querySelector('.ugc-v2-un');
      const mu = slide.querySelector('.ugc-v2-mu');
      if (pi && pa) {
        pi.style.display = v.paused ? 'block' : 'none';
        pa.style.display = v.paused ? 'none' : 'block';
      }
      if (un && mu) {
        un.style.display = v.muted ? 'none' : 'block';
        mu.style.display = v.muted ? 'block' : 'none';
      }
    }

    function openLb(idx) {
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ugc-v2-lock');
      initLbSwiper(idx);
      setTimeout(playActiveLbVideo, 200);
    }

    function closeLb() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ugc-v2-lock');
      pauseAllLbVideos();
    }

    // ---- Event bindings ----

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const i = parseInt(btn.getAttribute('data-ugc-open'), 10) || 0;
        openLb(i);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const i = parseInt(btn.getAttribute('data-ugc-open'), 10) || 0;
          openLb(i);
        }
      });
    });

    // Close on backdrop click
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        closeLb();
      });
    }

    // Close on close button
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeLb();
      });
    }

    // Escape to close
    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
    });

    // SINGLE unified click handler inside lightbox
    lightbox.addEventListener('click', function (e) {
      // 1. Close button
      if (e.target.closest('.ugc-v2-lb__close')) {
        closeLb();
        return;
      }
      // 2. Nav arrows → let Swiper handle (do nothing here)
      if (e.target.closest('.ugc-v2-lb__nav')) {
        return;
      }
      // 3. Play/Pause control button
      const pp = e.target.closest('[data-ugc-playpause]');
      if (pp) {
        e.stopPropagation();
        const slide = pp.closest('.swiper-slide');
        const v = slide.querySelector('[data-ugc-lb-video]');
        if (!v) return;
        if (v.paused) v.play().catch(function(){});
        else v.pause();
        updateIcons(slide);
        return;
      }
      // 4. Mute control button
      const mute = e.target.closest('[data-ugc-mute]');
      if (mute) {
        e.stopPropagation();
        const slide = mute.closest('.swiper-slide');
        const v = slide.querySelector('[data-ugc-lb-video]');
        if (!v) return;
        v.muted = !v.muted;
        updateIcons(slide);
        return;
      }
      // 5. Click on active video → toggle play/pause
      const videoWrap = e.target.closest('.ugc-v2-lb__video-wrap');
      if (videoWrap) {
        const slide = videoWrap.closest('.swiper-slide');
        if (slide && slide.classList.contains('swiper-slide-active')) {
          const v = slide.querySelector('[data-ugc-lb-video]');
          if (v) {
            if (v.paused) v.play().catch(function(){});
            else v.pause();
            updateIcons(slide);
          }
        }
        return;
      }
      // 6. Click on non-active slide → navigate to it
      const clickedSlide = e.target.closest('.swiper-slide');
      if (clickedSlide && lbSwiper) {
        const slideIdx = Array.from(lbSwiper.slides).indexOf(clickedSlide);
        if (slideIdx >= 0 && slideIdx !== lbSwiper.activeIndex) {
          lbSwiper.slideTo(slideIdx);
          return;
        }
      }
      // 7. Click on empty/outside area → close
      closeLb();
    });
  }

  function initAll() {
    waitForSwiper(function () {
      document.querySelectorAll('[data-ugc-section]').forEach(init);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      const s = e.target.querySelector('[data-ugc-section]');
      if (s) {
        delete s.dataset.ugcInit;
        waitForSwiper(function () { init(s); });
      }
    });
  }
})();